import { isDateOfBirthInPast } from "@finway-group/shared/lib/utils/date.utils"
import { DatePicker, Form } from "antd"
import moment, { type Moment } from "moment"
import React from "react"
import { useTranslation } from "react-i18next"
import { createRequiredDateOfBirthRules } from "~Components/forms/rules/employee.rule"
import { getPopupAnchor } from "~Shared/utils/popup.utils"

export const getDateOfBirthPickerProps = () => ({
    allowClear: false,
    disabledDate: (date: Moment) => !isDateOfBirthInPast(date),
    format: moment.localeData().longDateFormat("L"),
    getPopupContainer: getPopupAnchor(),
})

export const DateOfBirthFormItem = ({ inputClassName = "w-full" }: { inputClassName?: string }) => {
    const { t } = useTranslation()

    return (
        <Form.Item name="dateOfBirth" label={t("label:date_of_birth")} rules={createRequiredDateOfBirthRules()}>
            <DatePicker className={inputClassName} placeholder={t("label:date_of_birth")} {...getDateOfBirthPickerProps()} />
        </Form.Item>
    )
}
